<div class="single-banner">
  <ion-card (click)="routeTo(itemData)">
    <ion-img
      [src]="itemData?.img || itemData?.carousel_img || imagePlaceholder"
      (ionError)="itemData.carousel_img = imagePlaceholder"
    >
    </ion-img>
    <div class="text-overlay">
      <ion-card-title class="fs-4 font600">{{ itemData?.title }}</ion-card-title>
      <!-- <ion-card-subtitle>
        <ion-icon color="light" name="location-outline"></ion-icon>
        Pune, Maharashtra
      </ion-card-subtitle> -->
    </div>
  </ion-card>
  <div class="tag-text fs-4 font400" *ngIf="showCTA" (click)="routeTo(itemData)">
    {{ "home.single_banner.book_btn" | translate }}
  </div>
</div>
